import {Recipient, WhoToAdd, RecipientToAdd} from './QuickSelect'

export const buildRecipients = (
  selectedRecipients: Recipient[],
  hasStudentSquare: boolean,
  whoToAdd: WhoToAdd
) => {
  const recipientsToAdd: RecipientToAdd[] = []
  selectedRecipients.forEach((selectedRecipient) => {
    // Making this a special case, or any of the logic in the `else` is probably unneeded.
    // any "Person" returned should be contactable regardless of their type,
    // except the case where we invert the meaning of "student" to mean
    // "parents".
    if (selectedRecipient.isFamilyRecipient) {
      recipientsToAdd.push({
        recipient_type: 'Person',
        recipient_id: selectedRecipient.id,
        descriptive_name: `${selectedRecipient.last_name}, ${selectedRecipient.first_name}`,
        selected_user_type: selectedRecipient.type,
        user_ids: [parseInt(selectedRecipient.id)],
        isCoparent: selectedRecipient.type === 'Parent',
      })
    } else {
      // Handle regular recipients based on whoToAdd settings
      if (selectedRecipient.type === 'Student') {
        if (!hasStudentSquare || whoToAdd.user.includes('parents')) {
          selectedRecipient.parents?.forEach((parent) => {
            if (parent.login_allowed) {
              recipientsToAdd.push({
                recipient_type: 'Person',
                recipient_id: parent.id,
                descriptive_name: `${parent.last_name}, ${parent.first_name}`,
                selected_user_type: 'Parent',
                user_ids: [parseInt(parent.id)],
              })
            }
          })
        }
        if (whoToAdd.user.includes('students') && selectedRecipient.login_allowed) {
          // For students, use associated_user_id if available, otherwise use id
          const studentUserId = selectedRecipient.associated_user_id || selectedRecipient.id
          recipientsToAdd.push({
            recipient_type: 'Person',
            recipient_id: studentUserId,
            descriptive_name: `${selectedRecipient.last_name}, ${selectedRecipient.first_name}`,
            selected_user_type: selectedRecipient.type,
            user_ids: [parseInt(studentUserId)],
          })
        }
      } else if (['Parent', 'Staff', 'Guest'].includes(selectedRecipient.type)) {
        // Handle regular parents, staff, and guests
        recipientsToAdd.push({
          recipient_type: 'Person',
          recipient_id: selectedRecipient.id,
          descriptive_name: `${selectedRecipient.last_name}, ${selectedRecipient.first_name}`,
          selected_user_type: selectedRecipient.type,
          user_ids: [parseInt(selectedRecipient.id)],
        })
      }
    }

    if (selectedRecipient.type === 'Class') {
      const includedIds = new Set<number>()
      const who = whoToAdd.section
      if (who.includes('students')) {
        selectedRecipient.student_recipient_ids?.forEach(includedIds.add, includedIds)
      }
      if (who.includes('parents')) {
        selectedRecipient.parent_recipient_ids?.forEach(includedIds.add, includedIds)
      }
      if (who.includes('staff')) {
        selectedRecipient.staff_recipient_ids?.forEach(includedIds.add, includedIds)
      }

      if (includedIds.size > 0) {
        recipientsToAdd.push({
          recipient_type: 'Section',
          recipient_id: selectedRecipient.id,
          descriptive_name: selectedRecipient.full_name,
          selected_user_type: selectedRecipient.type,
          roles: who,
          user_ids: [...includedIds],
        })
      }
    }

    if (selectedRecipient.type === 'Group') {
      const includedIds = new Set<number>()
      const who = whoToAdd.group
      if (who.includes('everyone')) {
        selectedRecipient.student_recipient_ids?.forEach(includedIds.add, includedIds)
        selectedRecipient.parent_recipient_ids?.forEach(includedIds.add, includedIds)
        selectedRecipient.staff_recipient_ids?.forEach(includedIds.add, includedIds)
        selectedRecipient.guest_recipient_ids?.forEach(includedIds.add, includedIds)
      } else {
        if (who.includes('students')) {
          selectedRecipient.student_recipient_ids?.forEach(includedIds.add, includedIds)
        }
        if (who.includes('parents')) {
          selectedRecipient.parent_recipient_ids?.forEach(includedIds.add, includedIds)
        }
        if (who.includes('staff')) {
          selectedRecipient.staff_recipient_ids?.forEach(includedIds.add, includedIds)
        }
        if (who.includes('guests')) {
          selectedRecipient.guest_recipient_ids?.forEach(includedIds.add, includedIds)
        }
      }
      if (includedIds.size > 0) {
        recipientsToAdd.push({
          recipient_type: 'Group',
          recipient_id: selectedRecipient.id,
          descriptive_name: selectedRecipient.full_name,
          selected_user_type: selectedRecipient.type,
          roles: who.includes('everyone') ? ['all'] : who,
          user_ids: [...includedIds],
        })
      }
    }
  })

  return recipientsToAdd
}
